import React, { useState, useEffect } from "react"
import { Link, useParams } from "react-router-dom"
import {
  Table,
  CardBody,
  CardTitle,
  Button,
  Col,
  Row,
  UncontrolledAlert,
  Spinner,
} from "reactstrap"
import api from "API/Api"
import {
  AvForm,
  AvField,
  AvRadioGroup,
  AvRadio,
} from "availity-reactstrap-validation"

const VLCCAbsentees = () => {
  const { id } = useParams()
  const [submitted, setSubmitted] = useState(false)
  const [loading, setLoading] = useState(false)
  const [chillings, setChillings] = useState([])
  const [routes, setRoutes] = useState([])
  const [collections, setCollections] = useState([])
  const [producers, setProducers] = useState([])

  const handleValidSubmit = async (event, values) => {
    setLoading(true)
    try {
    const response = await api.put("update-vendor-recovery/" + id, values)
    if (response.data.success === true) setSubmitted(true)
    } catch (error) {

      // Handled by global interceptor

    }

    setLoading(false)
  }
  useEffect(() => {
    getData()
  }, [])

  const getData = async () => {
    const chResp = await api.get("centers")
    setChillings(Array.isArray(chResp.data.data) ? chResp.data.data : chResp.data.data?.data || [])
  }

  const chChangeHandler = async e => {
    const routeResp = await api.get("route-cc/" + e.target.value)
    setRoutes(Array.isArray(routeResp.data.data) ? routeResp.data.data : routeResp.data.data?.data || [])
  }
  const routeChangeHandler = async e => {
    const colResp = await api.get("collection-center-route/" + e.target.value)
    setCollections(Array.isArray(colResp.data.data) ? colResp.data.data : colResp.data.data?.data || [])
  }
  const ccChangeHandler = async e => {
    const proResp = await api.get("producer-center/" + e.target.value)
    setProducers(Array.isArray(proResp.data.data) ? proResp.data.data : proResp.data.data?.data || [])
  }

  return (
    <>
      <div className="dashBody">
        <div className="font-size-18 mb-0 dashHeader">
          <Row>
            <Col md={12}>
              <h4>VLCC Purchase Absentees Report</h4>
            </Col>
          </Row>
        </div>
        <div className="dashContent">
          <AvForm
            style={{ position: "relative" }}
            className="form-horizontal"
            onValidSubmit={(e, v) => {
              handleValidSubmit(e, v, "create")
            }}
          >
            <Row>
              <Col md={6}>
                <div className="mb-3">
                  <AvField
                    type="select"
                    name="chillingCenter"
                    label="Chilling Center"
                    required
                    onChange={e => chChangeHandler(e)}
                  >
                    <option value="">Select Chilling Center</option>
                    <option value="0">All Chilling Centers</option>
                    {chillings.map((chilling, i) => (
                      <option value={chilling.id} key={i}>
                        {chilling.name}
                      </option>
                    ))}
                  </AvField>
                </div>
              </Col>
              <Col md={6}>
                <div className="mb-3">
                  <AvField
                    type="select"
                    name="route"
                    label="Route"
                    required
                    onChange={e => routeChangeHandler(e)}
                  >
                    <option value="">Select Route</option>
                    <option value="0">All Routes</option>
                    {routes.map((route, i) => (
                      <option value={route.id} key={i}>
                        {route.routeName}
                      </option>
                    ))}
                  </AvField>
                </div>
              </Col>
              <Col md={6}>
                <div className="mb-3">
                  <AvField
                    type="select"
                    name="collectionCenter"
                    label="Center"
                    required
                    onChange={e => ccChangeHandler(e)}
                  >
                    <option value="">Select Center</option>
                    <option value="0">All Centers</option>
                    {collections.map((collection, i) => (
                      <option value={collection.id} key={i}>
                        {collection.centerName}
                      </option>
                    ))}
                  </AvField>
                </div>
              </Col>
              <Col md={6}>
                <div className="mb-3">
                  <AvField
                    type="select"
                    name="producer"
                    label="Producer"
                    required
                  >
                    <option value="">Select Producer</option>
                    <option value="0">All Producers</option>
                    {producers.map((producer, i) => (
                      <option value={producer.id} key={i}>
                        {producer.producerName}
                      </option>
                    ))}
                  </AvField>
                </div>
              </Col>
              <Col md={6}>
                <div className="mb-3">
                  <AvField
                    className="form-control"
                    label="Period From"
                    name="from"
                    type="date"
                    required
                  />
                </div>
              </Col>
              <Col md={6}>
                <div className="mb-3">
                  <AvField
                    className="form-control"
                    label="To"
                    name="to"
                    type="date"
                    required
                  />
                </div>
              </Col>
              <Col md={6}>
                <div className="mb-3">
                  <AvRadioGroup
                    inline
                    name="shift"
                    label="Shift"
                    required
                    errorMessage="Pick one!"
                  >
                    <AvRadio label="Both" value="0" />
                    <AvRadio label="AM" value="1" />
                    <AvRadio label="PM" value="2" />
                  </AvRadioGroup>
                </div>
              </Col>
            </Row>
            <div className="mb-3 row mt-4">
              <div className="col-6">
                {submitted ? (
                  <UncontrolledAlert color="success">
                    <strong>Vendor Recovery is Updated!</strong>
                  </UncontrolledAlert>
                ) : null}
              </div>
              <div className="col-6 text-end">
                <button
                  className="btn btn-primary w-md waves-effect waves-light"
                  type="submit"
                      disabled={loading}
                >
                  {loading ? (
                    <>
                      <Spinner animation="border" size="sm" />
                      <span style={{ paddingLeft: "10px" }}>Submitting...</span>
                    </>
                  ) : (
                    <span>Submit</span>
                  )}
                </button>
              </div>
            </div>
          </AvForm>
        </div>
      </div>
    </>
  )
}

export default VLCCAbsentees
